<template>
    <base-dialog v-model="dialog.show" max-width="500px" min-width="300px" scrollable
        :title="`${titleDialog} Thứ tự hiển thị trường`" width="50%">
        <div class="pb-1">Kéo thả để sắp xếp vị trí các trường</div>
        <draggable v-if="!loading" v-model="fields" group="people" @start="drag = true" @end="drag = false">
            <div v-for="(element, key) in fields" :key="element.id" class="d-flex align-center pa-1">
                <div style="width: 25px; font-weight: bold;">{{ +key + 1 }}.</div>
                <div class="d-flex align-center drag-field pa-1">
                    <div>
                        <v-icon meidum color="green darken-2">
                            mdi-cursor-move
                        </v-icon>
                    </div>
                    <div class="ml-2" style="font-weight: bold;">{{ element.name }}</div>
                </div>
            </div>
        </draggable>
        <div v-else style="height: 300px" class="d-flex align-center justify-center">
            <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </div>
        <template v-slot:extra-btn>
            <base-button color="primary" :loading="dialog.loading" outlined @click="onSubmit">
                Cập nhật
            </base-button>
        </template>
    </base-dialog>
</template>
  
<script>
import { API_FIELD } from '@api'
import { EDIT_TYPE, FIELD_TYPE_EDIT } from '@constant'
import draggable from 'vuedraggable'

export default {
    components: { draggable },
    props: {
        id: { type: Number, required: true },
    },
    data: () => ({
        dialog: {
            show: false,
            type: EDIT_TYPE.CREATE,
            error: {},
        },
        fields: [],
        loading: false,
    }),
    watch: {},
    computed: {
        titleDialog() {
            if (this.isCreateDialog) {
                return this.$i18n.t('actions.add')
            } else {
                return this.$i18n.t('actions.update')
            }
        },
        isCreateDialog() {
            return this.dialog.type == EDIT_TYPE.CREATE
        },
    },

    methods: {
        async getAllFileds() {
            this.loading = true;
            let data = await API_FIELD.list({ id: this.id });
            this.fields = [...data.data]
            this.loading = false
        },

        open(item, type) {
            if (this.$refs.form) this.$refs.form.resetValidation()
            this.getAllFileds()
            this.dialog.show = true
            this.dialog.type = type

            // let data = merge({ meta: { field: {}, items: [] }, visibility: {} }, item)
            // delete data.created_at
            // delete data.updated_at
            // this.dialog.data = Object.assign({}, data)
        },
        dialogClose() {
            this.dialog = {
                show: false,
                loading: false,
                data: { thuoc_tinh: { items: [] } },
                type: EDIT_TYPE.CREATE,
                error: {},
            }
        },
        async onSubmit() {
            this.dialog.error = {}
            try {
                const indexData = this.fields.map((item, index) => ({
                    id: item.id,
                    name: item.name,
                    index: index
                }));
                const res = await API_FIELD.createOrder({data: indexData})
                if (res && !res.error) {
                    this.dialogClose()
                    this.getData()
                }
                if (
                    res &&
                    res.error &&
                    res.error.response &&
                    res.error.response.status == 422
                ) {
                    const { response } = res.error
                    this.dialog.error = response.data.errors
                }
            } finally {
                this.dialog.loading = false
            }
        },
        getData() {
            this.$emit('reset')
        },
    },
}
</script>
  
<style scoped>
.drag-field {
    box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgb(209, 213, 219) 0px 0px 0px 1px inset;
    cursor: move;
    flex: 1;
}
</style>
  